import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { mockData } from '../mock';

const GallerySection = () => {
  const { gallery } = mockData;
  const [activeCategory, setActiveCategory] = useState('Plats');

  const categories = gallery.map(cat => cat.category);
  const currentImages = gallery.find(cat => cat.category === activeCategory)?.images || [];

  return (
    <section id="galerie" className="gallery-section section-padding">
      <div className="text-center mx-auto">
        <div className="section-title-wrap">
          <h2 className="card-surface section-title-badge text-4xl font-serif font-bold text-primary">
            Galerie Photos
          </h2>

          <p className="section-subtitle color-warm-white">
            Découvrez l'ambiance chaleureuse de notre restaurant et nos créations culinaires
          </p>
        </div>

        {/* Category filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {categories.map((category) => (
            <Button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2 rounded-full transition-all duration-200
              border border-warm-white
              ${activeCategory === category
                  ? 'bg-warm-white text-primary hover:bg-warm-white hover:text-primary'
                  : 'bg-transparent text-primary hover:bg-warm-white hover:text-secondary'
                }`}
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Image grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {currentImages.map((image, index) => (
            <Card key={index} className="card-hover overflow-hidden border-2 border-gray-100">
              <CardContent className="p-0">
                <div className="aspect-square relative overflow-hidden">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/0 hover:bg-black/20 transition-colors duration-300 flex items-end">
                    <div className="p-4 text-white transform translate-y-full hover:translate-y-0 transition-transform duration-300">
                      <p className="text-sm font-medium">{image.alt}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>


      </div>
    </section>
  );
};

export default GallerySection;